export const NewsDetailSkeleton = () => {
  return (
    <div className="animate-fade-in">
      {/* Hero image placeholder */}
      <div className="w-full h-[60vh] min-h-[400px] bg-muted skeleton-shimmer" />

      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-32 relative z-10">
        {/* Header card */}
        <div className="bg-card rounded-3xl p-6 sm:p-10 border border-border shadow-lg space-y-6">
          {/* Author + date row */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-muted skeleton-shimmer" />
            <div className="space-y-2">
              <div className="h-4 w-32 bg-muted rounded skeleton-shimmer" />
              <div className="h-3 w-20 bg-muted rounded skeleton-shimmer" />
            </div>
          </div>

          {/* Title */}
          <div className="space-y-3">
            <div className="h-8 sm:h-10 w-full bg-muted rounded skeleton-shimmer" />
            <div className="h-8 sm:h-10 w-4/5 bg-muted rounded skeleton-shimmer" />
          </div>

          {/* Content paragraphs */}
          <div className="space-y-3 pt-4">
            <div className="h-4 w-full bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-full bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-11/12 bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-full bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-3/4 bg-muted rounded skeleton-shimmer" />
          </div>

          <div className="space-y-3 pt-4">
            <div className="h-4 w-full bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-5/6 bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-full bg-muted rounded skeleton-shimmer" />
            <div className="h-4 w-2/3 bg-muted rounded skeleton-shimmer" />
          </div>
        </div>
      </article>
    </div>
  );
};

export default NewsDetailSkeleton;
